import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

export const NAV = [
  { label: "Início", href: "#inicio" },
  { label: "Acomodações", href: "#acomodacoes" },
  { label: "Galeria", href: "#galeria" },
  { label: "Diferenciais", href: "#diferenciais" },
  { label: "Localização", href: "#localizacao" },
  { label: "Contato", href: "#contato" },
];

export const Header = ({ top = 0, nav = NAV }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
  }, [open]);

  return (
    <header
      data-testid="site-header"
      style={{ top }}
      className={`fixed inset-x-0 z-40 transition-[background-color,border-color] duration-500 border-b ${
        scrolled || open ? "bg-[#08080A]/90 backdrop-blur-md border-white/10" : "bg-transparent border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-12 h-[72px] flex items-center justify-between">
        <a href="#inicio" data-testid="header-logo-link" aria-label="Gran Hotel Sé — início" className="shrink-0">
          <img src="/logo.png" alt="Gran Hotel Sé" className="h-9 sm:h-10 w-auto" width="120" height="40" />
        </a>
        <nav className="hidden lg:flex items-center gap-9" aria-label="Menu principal">
          {nav.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-link-${n.href.slice(1)}`}
              className="relative text-[0.7rem] uppercase tracking-[0.22em] text-[#E4E4E7] hover:text-white transition-colors duration-300 after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-[#C5A059] after:transition-[width] after:duration-500 hover:after:w-full"
            >
              {n.label}
            </a>
          ))}
        </nav>
        <button
          className="lg:hidden h-11 w-11 -mr-2 flex items-center justify-center text-white"
          onClick={() => setOpen((o) => !o)}
          aria-label={open ? "Fechar menu" : "Abrir menu"}
          aria-expanded={open}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="w-6 h-6" strokeWidth={1.2} /> : <Menu className="w-6 h-6" strokeWidth={1.2} />}
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="mobile-menu"
            aria-label="Menu móvel"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="lg:hidden fixed inset-x-0 top-[72px] h-[calc(100dvh-72px)] bg-[#08080A] px-6 pt-10 flex flex-col"
          >
            {nav.map((n, i) => (
              <motion.a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${n.href.slice(1)}`}
                initial={{ opacity: 0, x: -16 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.05 * i }}
                className="font-display text-3xl text-white py-4 border-b border-white/10"
              >
                {n.label}
              </motion.a>
            ))}
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
